import axios from './_nestAxios'

export const obtenerAsCuadresCombustibles = () => axios.get('/cuadres-combustibles', { params: { tipoConsulta: 'obtener-todo' } })

export const recuperarVentasDelTurno = () => axios.get('/cuadres-combustibles/', { params: { tipoConsulta: 'recuperar-ventas' } })

export const obtenerAsDetallesTurnos = params => axios.get('/cuadres-combustibles', { params: { ...params, tipoConsulta: 'detalles-turnos' } })

export const guardarCuadresCombustiblesAsArray = ({ data, arrayVentasRecuperadas }) =>
  axios.post('/cuadres-combustibles', { data, arrayVentasRecuperadas })
